import "./styles.scss";

import { useTranslation } from "react-i18next";
import * as Material from "@mui/material";

export default function EditionModeButton({ editingEnabled, onToggle }) {
    const { t } = useTranslation("content");

    return (
      <div className={`admin-edit-control ${editingEnabled ? 'editing-enabled' : ''}`}>
        <Material.FormControlLabel
          control={
            <Material.Switch
              checked={editingEnabled}
              onChange={(e) => onToggle(e.target.checked)}
              name="editingEnabled"
              color="primary"
              size="small"
            />
          }
          label={<span style={{ marginLeft: '-6px' }}>
            {editingEnabled ? t('section.editingEnabled') : t('section.enableEditing')}
          </span>}
        />
      </div>
    );
  }